import { reportClientError } from '../../../app/_components/chrome/scripts/DataDogRumScript'

// shortcut: dedupes per page load, not per SPA view; fine for failure-only volume.
const reportedKeys = new Set<string>()

/**
 * Reports an embroidery failure to RUM under `category: 'embroidery'`. The error message is the
 * label so Error Tracking groups one issue per label. Context must not hold embroidered text,
 * logo filenames or URLs.
 */
export function reportEmbroideryError(
  label: string,
  context?: Record<string, string>,
  options?: { cause?: unknown; dedupeKey?: string }
) {
  if (options?.dedupeKey !== undefined) {
    const key = `${label}:${options.dedupeKey}`
    if (reportedKeys.has(key)) return
    reportedKeys.add(key)
  }
  const cause = options?.cause
  reportClientError({
    error: new Error(label),
    context: {
      category: 'embroidery',
      label,
      ...(cause !== undefined && {
        causeMessage: cause instanceof Error ? cause.message : String(cause),
      }),
      ...context,
    },
  })
}

/** Reports a selection change the rules refused where the editor has no message to show for it. */
export function reportSelectionRefused(reason: string, typeKey: string, placementIds: string[]) {
  // 'none' when the refused save was emptying the editor
  const placements = placementIds.join(',') || 'none'
  reportEmbroideryError(
    'embroidery-selection-refused',
    { reason, typeKey, placementIds: placements },
    { dedupeKey: `${reason}:${typeKey}:${placements}` }
  )
}
